import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

class RemoveSubjectMember {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly userId: number,
	) {
		Object.freeze(this);
	}
}

export default RemoveSubjectMember;
